// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// vue和react一起使用：
// 1 vuera https://blog.csdn.net/qq_42033567/article/details/118463487
// 2 https://github.com/devilwjp/veaury/blob/master/README_zhcn.md
// import { VuePlugin } from 'vuera'
// Vue.use(VuePlugin)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import axios from 'axios'
Vue.prototype.$http= axios

Vue.prototype.$uploadUrl="https://www.daostarter.pro/api/starter/upload"

Vue.config.productionTip = false

import "@/utils/logConfig"
//import SID, {getSidAddress} from '@siddomains/sidjs'

Vue.filter("setAccountEllipsis",(value)=>{
  if(value){
    return value.substring(0,5)+'...'+value.substring(value.length - 5)
  }
})
Vue.filter("convert_18",(value)=>{
  if(value){
    //toFixed() 方法可把 Number 四舍五入为指定小数位数的数字。
    return  (value / Math.pow(10, 18)).toFixed(3);
  }
})

Vue.prototype.$setLink=function(value){
  if(value){
    return value.replace(/\<a/gi, '<a target="_blank" style="font-size: 16px;line-height: 29px;color: #27DEBF;text-decoration:underline"');
  }
}

let charinArr={

    1:{
      name:'ETH',
      logo:"https://cdn.daostarter.pro/chainLogo/ETH.png",
      unit:'ETH'
    },
    56:{
      name:'BSC',
      logo:"https://cdn.daostarter.pro/chainLogo/BSC.png",
      unit:'BNB'
    },
    66:{
      name:'OKC',
      logo:"https://cdn.daostarter.pro/chainLogo/OKX.png",
      unit:'OKT'
    },
    137:{
      name:'Polygon',
      logo:"https://cdn.daostarter.pro/chainLogo/Polygon.png",
      unit:'MATIC'
    },
    /*70:{
      name:'HSC',
      logo:"https://cdn.daostarter.pro/chainLogo/HSC.png",
      unit:'HOO'
    },*/
    256256:{
      name:'CMP',
      logo:"https://cdn.daostarter.pro/cmp.png",
      unit:'CMP'
    },
    592:{
      name:'Astar Network',
      logo:"https://cdn.daostarter.pro/poweredBy%2FAstar.png",
      unit:'ASTR'
    },
    /*8080:{
      name:'Shardeum Liberty1.X',
      logo:"https://cdn.daostarter.pro/SHM.png",
      unit:'SHM'
    },*/
    42161:{
      name:'ArbitrumOne',
      logo:"https://cdn.daostarter.pro/poweredBy/Arbitrum_logo.png",
      unit:'ETH'
    },
    10:{
      name:'Optimism',
      logo:"https://cdn.daostarter.pro/poweredBy/OPTIMISM-Logo.png",
      unit:'ETH'
    },
    8082:{
      name:'Shardeum Sphinx 1.X',
      logo:"https://cdn.daostarter.pro/SHM.png",
      unit:'SHM'
    },
    324:{
      name:'zkSync Era',
      logo:"https://cdn.daostarter.pro/zksync.png",
      unit:'ETH'
    },
    7000:{
      name:'ZetaChain',
      logo:"https://cdn.daostarter.pro/ZetaChain.jpg",
      unit:'ZETA'
    },
    8453:{
      name:'Base',
      logo:"https://cdn.daostarter.pro/chainLogo/BASE.png",
      unit:'ETH'
    },
    165:{
      name:'Omni Testnet',
      logo:"https://cdn.daostarter.pro/omni.png",
      unit:'OMNI'
    },
    59144:{
      name:'Linea',
      logo:"https://cdn.daostarter.pro/linea-logo1.png",
      unit:'ETH'
    },
    2525:{
      name:'inEVM',
      logo:"https://cdn.daostarter.pro/inj-logo.png",
      unit:'INJ'
    },
    81457:{
    name:'Blast',
    logo:"https://cdn.daostarter.pro/longSlider/blast-logo.jpg",
    unit:'ETH'
    },
    4200:{
    name:'Merlin-EVM',
    logo:"https://cdn.daostarter.pro/Merlin-logo.jpg",
    unit:'BTC'
    },
    195:{
    name:'X1-Test',
    logo:"https://cdn.daostarter.pro/longSlider/X1.jpg",
    unit:'OKB'
    },
    80085:{
    name:'Bera-Test',
    logo:"https://cdn.daostarter.pro/longSlider/BERA.svg",
    unit:'BERA'
    },
    /*204 :{
    name:'opBNB',
    logo:"https://cdn.daostarter.pro/linea-logo1.png",
    unit:'opBNB'
    },
  /*80000:{
  name:'BTC',
    logo:"https://cdn.daostarter.pro/chainLogo/ETH.png",
    unit:'BTC'
  },*/
    // 256:{
    //   name:'HECOTEST',
    //   unit:'HECOTEST'
    // },
}

Vue.filter("getCharLogo",(value)=>{
  if(value && charinArr[value]){
    return charinArr[value].logo
  }else{
    return "https://cdn.daostarter.pro/chainLogo/WrongNetwork.png";
  }
})

Vue.filter("getBalanceUnit",(value)=>{
  if(value && charinArr[value]){
    return charinArr[value].unit
  }
})

Vue.filter("chainName",(value)=>{
  console.log("value=============",value);
  if(value && charinArr[value]){
    return charinArr[value].name
  }else{
    return "Wrong Network";
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js